import '@angular/compiler';
import '@angular/common';
import 'zone.js';

//force include thirt party js content to vendor js START
require('jquery-confirm');
//force include thirt party js content to vendor js END

import 'jquery';
import 'jquery-ui';

import { IoCContainer, WebCoreIoCKeys } from '@lmnop/web-core';
import { AngularCoreIoCKeys } from '@lmnop/angular-core';
import { AppIoCContainer, AppIoCKeys, AppModule, AppSettings } from 'app-src';

//IoCContainer.bind START
IoCContainer.bindSingletonType(AppIoCKeys.IAppIoCContainer, AppIoCContainer);
IoCContainer.bindSingletonType(AppIoCKeys.IAppSettings, AppSettings);
IoCContainer.setSingletonType(WebCoreIoCKeys.ITranslation, AngularCoreIoCKeys.IAngularTranslation);
//IoCContainer.bind END

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Diagnostic, ApplicationType } from '@lmnop/web-core';

//import to avoid dev mode angular warning
import * as EnvironmentProd from 'environments-src/environment.prod';

import { Environment } from 'environments-src';

Diagnostic.debug('applicationInitializer - init started');
Diagnostic.isProductionMode = Environment.production;
Diagnostic.applicationType = ApplicationType.webApplication;
Diagnostic.init();
Diagnostic.debug('applicationInitializer - init ended');

if (Environment.production) {
    enableProdMode();
}

// creating bootstrap
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((error: any): void => {
        Diagnostic.handleError(error);
    });
